import $ from "jquery";
import {crossRecommenderViewHandler, crossRecommenderClickHandler, crossRecommenderGetListHandler} from "../../common/dataLayer/data-layer-metrica-handlers";
import {isMobile} from "Core/screenSizes";
const selector = '.cross-platform';
window.SPRTS_STATUS = false;
window.SPRTS = window.SPRTS || {};
window.SPRTS.q = window.SPRTS.q || [];

export const crossRecommenderSendData = () => {
    if (window.materialParams === undefined) {
        return;
    }

    let script = document.createElement('script');
    script.src = "https://senoval.cdn.sports.ru/cross-recommender/recommender.es.js";
    script.async = true;
    document.head.append(script);

    script.onerror = function () {
        alert("Ошибка загрузки " + this.src);
    };

    window.SPRTS.q.push(() => {
        window.SPRTS.initRecommender({
            domain: 'gol.ru',
            partner: 'gol.ru',
            uidAuth: window.materialParams.uidAuth,
        })
    });

    window.SPRTS.q.push(() => {
        window.addEventListener(window.SPRTS.senderEventName, function () {
            sendMaterialData($('.material-content__parts-wrapper').data('id'));
            window.SPRTS_STATUS = true;
        });
    });

    // script.onload = function () {
    //     window.SPRTS && window.SPRTS.initRecommender({
    //         domain: 'gol.ru',
    //         partner: 'gol.ru',
    //         uidAuth: window.materialParams.uidAuth,
    //     });
    //
    //     window.addEventListener(window.SPRTS.senderEventName, function () {
    //         sendMaterialData($('.material-content__parts-wrapper').data('id'));
    //         window.SPRTS_STATUS = true;
    //     });
    // };
}

export const crossRecommenderHandler = (id) => {
    $(document).on('click', `${selector} .related-materials-in-content__item-wrapper`, function (event) {

        const data = $(this).data();

        crossRecommenderClickHandler(data.id, data.type, 'undercontent', data.model);

        window.SPRTS.sendAnalytics({
            content: {id: data.id, type: data.type},
            action: 'teaser_click'
        });

        return true;
    });

    if ($(selector).length === 0) {
        return;
    }

    if (window.materialParams === undefined) {
        return;
    }

    if(window.SPRTS.getPersonalRecs !== undefined){
        getPersonalRecsForMaterial(id);
    } else{
        window.SPRTS.q.push(() => {
            window.addEventListener(window.SPRTS.senderEventName, function () {
                getPersonalRecsForMaterial(id);
            });
        });
    }

    // if (window.SPRTS_STATUS) {
    //     getPersonalRecsForMaterial(id);
    // } else {
    //     let timerId = setInterval(function () {
    //         if (window.SPRTS_STATUS) {
    //             getPersonalRecsForMaterial(id);
    //             clearTimeout(timerId);
    //         }
    //     }, 200);
    // }
}

export const sendMaterialData = (id) => {
    window.SPRTS && window.SPRTS.sendDataForRecommender({
        content: {
            id: window.materialParams[id].id,
            type: window.materialParams[id].type,
            ctime: window.materialParams[id].ctime,
            url: window.materialParams[id].url,
            image: window.materialParams[id].image,
            title: window.materialParams[id].title,
            section: window.materialParams[id].section || null,
        }
    });
}

const getPersonalRecsForMaterial = (id)=>{
    let observer = new IntersectionObserver(onIntersectionObserve);

    let parent = $(`.material-content__parts-wrapper[data-id=${id}]`).find(`${selector}:first`);

    if(isMobile()){
        parent = $(`.material-content__parts-wrapper[data-id=${id}]`).find(`.partners-widget--mobile ${selector}`);
    }

    const wrapper = parent.find('.related-materials-in-content__materials-wrapper');

    if (wrapper.find('article').length > 0) {
        return;
    }

    crossRecommenderGetListHandler('undercontent', "own");

    window.SPRTS.getPersonalRecs({
        "config": 'web_underpost'
    })
        .then((result) => {
            if (wrapper.length > 0) {
                wrapper.empty();

                for (const i in result.items) {
                    const partner = result.items[i].url.indexOf('sports.ru')!==-1 ?
                        '<div class="related-materials-in-content__item-headline--label">партнерский материал</div>':
                        '';
                    wrapper.append(`<article>
                            <div class="related-materials-in-content__item-wrapper" 
                                 data-id="${result.items[i].id}"
                                 data-type="${result.items[i].type}"
                                 data-model="${result.model}">
                                <div class="related-materials-in-content__image">
                                    <a href="${result.items[i].url}" ${result.items[i].url.indexOf('gol.ru') !== -1 || result.items[i].url.indexOf('/') === 0 ? '' : 'target="_blank"'}>
                                        <img src="${result.items[i].image}" alt="" loading="lazy">
                                    </a>
                                </div>
                                <div class="related-materials-in-content__item-headline">
                                    ${partner}
                                    <a href="${result.items[i].url}" ${result.items[i].url.indexOf('gol.ru') !== -1 || result.items[i].url.indexOf('/') === 0 ? '' : 'target="_blank"'}>${result.items[i].title}</a>
                                </div>
                            </div>
                        </article>`);
                }

                observer.observe(wrapper[0]);
            }
        })
        .catch((error) => {
            console.log('getPersonalRecs error', error);
        });
}

const onIntersectionObserve = (entries, observer) => {
    entries.forEach(entry => {
        if (!entry.isIntersecting) {
            return;
        }

        const data = $(entry.target).find('.related-materials-in-content__item-wrapper').data();

        crossRecommenderViewHandler('undercontent', data.model);

        window.SPRTS.sendAnalytics({
            content: {id: data.id, type: data.type},
            action: 'teaser_view'
        });

        observer.unobserve(entry.target);
    });
};
